import $ from 'jquery';
import ko from 'knockout';

import Typeahead from 'typeahead';
import Bloodhound from 'bloodhound';

/*** Typeahead custom binding */
ko.bindingHandlers.typeahead = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const $element = $(element);
        const value = valueAccessor() || {};
        const allBindings = allBindingsAccessor() || {};

        const args = {
            options: allBindings.typeaheadOptions,
            bindings: {
                Remote: allBindings.typeaheadRemote,
                Data: allBindings.typeaheadData,
                OnLoad: allBindings.typeaheadOnLoad,
                RateLimitWait: allBindings.typeaheadRateLimitWait
            }
        }

        const remote = args.bindings.Remote;
        const data = ko.unwrap(args.bindings.Data) || {};

        // init defaults
        if (remote === undefined && data === undefined) throw ("typeahead data or remote server required.");

        if (remote !== undefined) {
            // add dispose
            var source = new Bloodhound({
                datumTokenizer: str => str,
                queryTokenizer: str => str,
                remote: {
                    url: remote,
                    prepare: function (query, settings) {
                        var name = args.options.name || element.id;

                        settings.data = data;
                        settings.data[name] = query;

                        if (args.bindings.OnLoad != undefined) {
                            args.bindings.OnLoad(settings.data);
                        }

                        return settings;
                    },
                    rateLimitWait: args.bindings.RateLimitWait != undefined ? args.bindings.RateLimitWait : 300
                }
            });

            var dataSets = $.extend({
                classNames: {
                    wrapper: 'tt-wrap'
                },
                limit: 50,
                minLength: 2,
                highlight: false,
                source: source,
            }, args.options);

            $element.typeahead(args.options, dataSets);
        } else if (data !== undefined) {
            var dataSets = $.extend({
                classNames: {
                    wrapper: 'tt-wrap'
                },
                limit: 50,
                minLength: 2,
                highlight: false,
                source: data,
            }, args.options);

            $element.typeahead(args.options, dataSets);
        }

        var $floating = $element.closest(".form-floating");
        if ($floating.length) {
            const wrp = $floating.find(".tt-wrap");
            const label = $floating.find("label");
            const hint = $floating.find(".form-control.tt-hint");

            wrp.css("display", "block");
            hint.removeClass("form-control");
            hint.addClass("form-control-hint");

            label.appendTo(wrp);
        }

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => $element.typeahead("destroy") );
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const observable = valueAccessor() || {};
        const value = ko.unwrap(observable);
        $(element).typeahead('val', value);
    }
};